<template>
	<v-overlay :absolute="isAbsolute" :opacity="0.4" :z-index="999">

		<!-- дефолт: показуємо лише якщо НЕ активні жодні «сезонні» вікна -->
		<div
				v-if="$inWindowNone([ DATE.HALLOWEEN, DATE.WINTER ])"
				class="center"
		>
<!--			<v-progress-circular indeterminate size="80" color="green"/>-->
			<default-loader/>
		</div>

		<!-- halloween -->
		<div v-if="$inWindow(DATE.HALLOWEEN)" class="loaderWrapper">
			<helloween-loader/>
		</div>

		<!-- winter -->
		<div v-if="$inWindow(DATE.WINTER)" class="loaderWrapper">
			<christmas-loader/>
		</div>
	</v-overlay>
</template>

<script>
import { DATE } from "@/constants/date";
import helloweenLoader from "@/shared/Preload/halloween-loader.vue";
import ChristmasLoader from "@/shared/Preload/christmas-loader.vue";
import DefaultLoader from "@/shared/Preload/default-loader.vue";

export default {
	name: "Preload",
	components: {
		DefaultLoader,
		ChristmasLoader,
		helloweenLoader
	},
	props: {
		isAbsolute: Boolean
	},
	data: () => ({ DATE }),
	mounted() {
		this.checkSeason();
	},
	methods: {
		checkSeason() {
			if (this.$inWindow(DATE.HALLOWEEN)) {
				console.info("HALLOWEEN active:", DATE.HALLOWEEN);
			}
		}
	}
};
</script>

<style scoped lang="scss">
.loaderWrapper {
	width: 400px;
	height: 400px;
	display: block;
	position: fixed;
	top: calc(50% - 200px);
	left: calc(50% - 200px);
}
</style>
